import React, { useEffect, useState } from "react";

import { View, StyleSheet, TouchableOpacity } from "react-native";

import { BallIndicator } from "react-native-indicators";
import ConfirmAlert from "component/alert/ConfirmAlert";

import Toast from "component/toast";
import Icon from "component/typography/Icon";
import Text from "component/typography/Text";
import Button from "component/button/Button";
import CartCountSlider from "component/section/CartCountSlider";
import ConfirmAlertCard from "component/section/ConfirmAlertCard";
import CartItemDescription from "component/section/CartItemDescription";

import { colors, sizes, strings } from "asset/constant";
import { isEqualArrays, mq } from "utils";
import { useRecoilValue } from "recoil";
import { cartAtom } from "store";
import { useFlag } from "hook";
import { css } from "style";

import { useChangeCartItem, useRemoveCartItem } from "client/api";

interface ChangeCartItemT {
  inCart?: boolean;
  count?: number;
  disabled?: boolean;
  productId?: number;
  variations?: Array<VariationItemT>;
  id?: string;
  companyId?: number;
  desc?: string;
  step: number;
}

export default function AddAndChangeCartItem(props: ChangeCartItemT) {
  const {
    id,
    inCart,
    count,
    desc,
    disabled,
    productId,
    variations,
    companyId,
    step,
  } = props;
  const cart = useRecoilValue(cartAtom);

  const [countState, setCountState] = useState(Number(count));
  const [idState, setIdState] = useState("");
  const [cartItemDesc, setCartItemDesc] = useState(desc);

  const { flg: alert, on: showAlert, off: hideAlert } = useFlag();
  const { flg: slider, on: showSlider, off: hideSlider } = useFlag();
  const { flg: descInput, on: showDescInput, off: hideDescInput } = useFlag();

  useEffect(() => {
    if (!inCart) {
      const current = variations?.map((v) => v.id) || [];
      const products = cart?.products ?? [];
      const length = products?.length;

      if (length > 0) {
        for (let key = 0; key < length; key++) {
          const thisProduct = products[key];
          if (
            productId === thisProduct.product_id &&
            isEqualArrays(
              thisProduct.attribute_items.map((e) => e.id),
              current
            )
          ) {
            setCartItemDesc(thisProduct.description);
            setCountState(thisProduct?.count);
            setIdState(thisProduct?.id);
            break;
          }
          setCountState(0);
          setCartItemDesc("");
        }
      } else {
        setCountState(0);
        setCartItemDesc("");
      }
    }
  }, [cart, inCart, productId, variations]);

  useEffect(() => {
    if (inCart) {
      setCountState(Number(count));
    }
  }, [count, inCart]);

  const changeCartItemMut = useChangeCartItem();
  const removeCartItemMut = useRemoveCartItem(id ? id : idState);

  const _onChangeCartItem = (val: number, descriptionValue?: string) => {
    if (
      !inCart &&
      cart &&
      cart?.products?.length > 0 &&
      cart?.company.id !== companyId
    ) {
      Toast.warning({ message: strings.company_is_different });
      return;
    }

    if (
      variations &&
      variations?.findIndex((v) => v.is_customized === 1) > -1 &&
      !descriptionValue
    ) {
      Toast.warning({ message: strings.insert_cart_item_description });
      return;
    }

    const postData: ChangeCartItemReqT = {
      count: val,
      attributes: variations?.map((v) => Number(v?.id)),
      description: descriptionValue,
      // price_ration:
    };

    changeCartItemMut.mutate({ id: productId, data: postData });
  };

  const _onPlus = () => _onChangeCartItem(step, cartItemDesc);
  const _onMinus = () =>
    countState > step && _onChangeCartItem(-step, cartItemDesc);
  const _onDelete = () => removeCartItemMut.mutate();

  const _disabledAlert = () => {
    Toast.warning({ message: "ویژگی های محصول را انتخاب کنید" });
    return;
  };

  const _customizedProductAlert = () => {
    Toast.warning({ message: "تعداد این محصول را در بخش توضیحات مشخص کنید" });
    return;
  };

  return (
    <>
      <View style={{ ...css.container, ...css.row }}>
        <View style={styles.box}>
          {countState > 0 ? (
            <>
              <View style={styles.buttonsContainer}>
                <View
                  style={{
                    ...css.rRowCenterAlign,
                    height: mq(42),
                    borderWidth: mq(1),
                    paddingHorizontal: mq(3),
                    borderRadius: sizes.radius.lg,
                    borderColor: colors.bg.minusBtn,
                  }}
                >
                  {variations?.findIndex((e) => e.is_customized === 1) >
                  -1 ? null : (
                    <Button
                      disabled={
                        variations?.findIndex((e) => e.is_customized === 1) > -1
                      }
                      onPress={_onPlus}
                      style={{ borderRadius: sizes.radius.md }}
                      width={mq(35)}
                      height={mq(35)}
                      bgColor={colors.info}
                      icon={{ name: "plus", size: mq(22), color: colors.white }}
                    />
                  )}
                  <TouchableOpacity
                    activeOpacity={changeCartItemMut?.isLoading ? 1 : 0.9}
                    onPress={
                      variations?.findIndex((e) => e.is_customized === 1) > -1
                        ? _customizedProductAlert
                        : changeCartItemMut?.isLoading
                        ? undefined
                        : showSlider
                    }
                    style={{ width: mq(50), ...css.centralElements }}
                  >
                    {changeCartItemMut?.isLoading ? (
                      <>
                        <BallIndicator size={mq(20)} color={colors.theme} />
                      </>
                    ) : (
                      <Text
                        weight="extraBold"
                        size={mq(18)}
                        color={colors.text.dark}
                      >
                        {countState}
                      </Text>
                    )}
                  </TouchableOpacity>
                  {variations?.findIndex((e) => e.is_customized === 1) >
                  -1 ? null : (
                    <Button
                      disabled={
                        variations?.findIndex((e) => e.is_customized === 1) > -1
                      }
                      onPress={_onMinus}
                      style={{ borderRadius: sizes.radius.md }}
                      width={mq(35)}
                      height={mq(35)}
                      bgColor={"#e8e8e8"}
                      icon={{
                        name: "minus",
                        size: mq(24),
                        color: colors.text.normal,
                      }}
                    />
                  )}
                </View>

                <View
                  style={{
                    ...css.centralElements,
                    width: mq(42),
                    marginLeft: mq(8),
                    height: mq(42),
                    borderWidth: mq(1),
                    borderColor: colors.bg.minusBtn,
                    borderRadius: sizes.radius.lg,
                  }}
                >
                  <Button
                    loading={removeCartItemMut.isLoading}
                    loadingProps={{ size: mq(20) }}
                    onPress={inCart ? showAlert : _onDelete}
                    bgColor={colors.danger}
                    width={mq(35)}
                    height={mq(35)}
                    icon={{ name: "delete", size: mq(22) }}
                    style={{ borderRadius: sizes.radius.md }}
                  />
                </View>
              </View>
            </>
          ) : (
            <Button
              onPress={_onPlus}
              width={mq(178)}
              height={mq(48)}
              bgColor={colors.transparent}
              renderContent={() => {
                return changeCartItemMut.isLoading ? (
                  <View
                    style={{
                      ...css.centralElContainer,
                      borderRadius: sizes.radius.lg,
                      backgroundColor: colors.bg.lightest,
                      borderWidth: mq(1),
                      borderColor: colors.border.light,
                    }}
                  >
                    <BallIndicator size={mq(20)} color={colors.theme} />
                  </View>
                ) : (
                  <View style={{ ...css.container, ...css.rRowCenterAlign }}>
                    <View
                      style={{
                        height: mq(42),
                        ...css.ratio(1),
                        borderWidth: mq(1),
                        borderRadius: sizes.radius.lg,
                        borderColor: colors.bg.minusBtn,
                        ...css.centralElements,
                      }}
                    >
                      <View
                        style={{
                          height: mq(35),
                          ...css.ratio(1),
                          ...css.centralElements,
                          ...css.bgColor(colors.theme),
                          borderRadius: sizes.radius.md,
                        }}
                      >
                        <Icon
                          size={mq(22)}
                          color={colors.white}
                          name="shoppingcart"
                        />
                      </View>
                    </View>
                    <Text
                      weight="extraBold"
                      color={colors.theme}
                      size={"lg"}
                      style={{ paddingRight: mq(8) }}
                    >
                      افزودن به سبد خرید
                    </Text>
                  </View>
                );
              }}
            />
          )}

          {(disabled ||
            changeCartItemMut.isLoading ||
            removeCartItemMut.isLoading) && (
            <TouchableOpacity
              activeOpacity={1}
              onPress={disabled ? _disabledAlert : undefined}
              style={{
                ...css.fixFitContent,
                borderRadius: sizes.radius.lg,
                backgroundColor: colors.white + "22",
              }}
            />
          )}
        </View>
        {variations &&
          variations?.findIndex((e) => e.is_customized === 1) > -1 && (
            <View style={{ ...css.container }}>
              <TouchableOpacity onPress={showDescInput}>
                <View style={{ ...css.rRowCenterAlign }}>
                  <View
                    style={{
                      height: mq(42),
                      ...css.ratio(1),
                      borderWidth: mq(1),
                      borderRadius: sizes.radius.lg,
                      borderColor: colors.bg.minusBtn,
                      ...css.centralElements,
                    }}
                  >
                    <View
                      style={{
                        height: mq(35),
                        ...css.ratio(1),
                        ...css.centralElements,
                        ...css.bgColor(colors.info),
                        borderRadius: sizes.radius.md,
                      }}
                    >
                      <Icon
                        size={mq(20)}
                        color={colors.white}
                        name="message1"
                      />
                    </View>
                  </View>

                  <Text color={colors.info} weight="extraBold">
                    {" "}
                    توضیحات
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
          )}
      </View>

      <ConfirmAlert
        force
        show={alert}
        hide={hideAlert}
        renderContent={(close) => (
          <ConfirmAlertCard
            icon={{ name: "delete" }}
            title={strings.remove_cart_item}
            message={strings.you_want_remove_cart_item}
            subMessage={strings.are_you_sure}
            noTitle={strings.cancel}
            onNoPress={close}
            yesTitle={strings.confirm}
            onYesPress={() => {
              close();
              _onDelete();
            }}
          />
        )}
      />

      <CartItemDescription
        description={cartItemDesc}
        visible={descInput}
        hide={hideDescInput}
        onConfirm={(val) => {
          setCartItemDesc(val);
          _onChangeCartItem(1, val);
        }}
      />

      <CartCountSlider
        step={step}
        count={Number(countState)}
        visible={slider}
        hide={hideSlider}
        onApply={(output) => {
          if (output - countState !== 0) {
            _onChangeCartItem(output - countState, cartItemDesc);
          }
        }}
      />
    </>
  );
}

const styles = StyleSheet.create({
  box: {
    width: mq(182),
    height: mq(48),
    ...css.centralElements,
    borderRadius: sizes.radius.lg,
  },

  buttonsContainer: { flexDirection: "row", width: mq(178) },
});
